export default {
	overlayConfig_Detailed: 'overlayConfig_Detailed',
	overlayConfig_Minimal: 'overlayConfig_Minimal',
};
